
(function() {
  function initCollapse() {
    if (!window.location.pathname.includes('/collections/')) return;

    const desc = document.querySelector('rte-formatter.text-block.paragraph');
    if (!desc) return;

    // Évite de refaire le traitement si déjà fait
    if (desc.closest('.description-collapsible')) return;

    // On crée un wrapper qu'on contrôle nous-mêmes
    const wrapper = document.createElement('div');
    wrapper.className = 'description-collapsible';
    desc.parentNode.insertBefore(wrapper, desc);
    wrapper.appendChild(desc);

    // On attend que le DOM calcule la hauteur réelle
    requestAnimationFrame(() => {
      // Si c'est déjà court, pas besoin de bouton
      if (wrapper.scrollHeight <= 120) {
        wrapper.classList.add('is-short');
        return;
      }

      const btn = document.createElement('button');
      btn.className = 'description-toggle-btn';
      btn.type = 'button';
      btn.textContent = 'Lire la suite ↓';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', () => {
        const expanded = wrapper.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Réduire ↑' : 'Lire la suite ↓';
        btn.setAttribute('aria-expanded', expanded);
      });

      wrapper.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapse);
  } else {
    initCollapse();
  }
})();